import { FormFieldProps } from "./FormFieldProps";

export const getFormFieldProps = (props: object) => {
  const propsToExtract: (keyof FormFieldProps)[] = [
    "id",
    "labelId",
    "label",
    "infoTooltip",
    "helperText",
    "error",
    "required",
    "children",
    "count",
    "maxCount",
    "disabled",
    "components",
    "sx",
  ];

  const result = {} as FormFieldProps;

  propsToExtract.forEach((prop) => {
    if (prop in props) {
      result[prop] = props[prop as keyof typeof props];
    }
  });

  return result;
};
